export default __webpack_public_path__ + "static/media/Header@2x.dc48c1c9.png";